import { render, staticRenderFns } from "./ContactUsClient.vue?vue&type=template&id=3da85d8b&scoped=true"
import script from "./ContactUsClient.vue?vue&type=script&lang=js"
export * from "./ContactUsClient.vue?vue&type=script&lang=js"
import style0 from "./ContactUsClient.vue?vue&type=style&index=0&id=3da85d8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da85d8b",
  null
  
)

export default component.exports